import { TransportService } from '@ql-midle/apollo-client';
import { getUrlParams, fillParams } from '../utils/UtilsUrl';
import { BaseOption } from '@ql-midle/apollo-client';
import { getVal } from '../../lib/utils/UtilsCommon';
import { updateCategoryList } from '../../redux/actions/modules/ModulesActionsCommon';

/**
 * 通用参数
 */
interface IApiParams {
	url: string;
	method?: 'post' | 'get';
	body?: any;
}

/**
 * common
 *
 * @class ServiceBase
 * @extends {TransportService}
 */
class ServiceBase extends TransportService {
	private store: any = null;

	constructor() {
		super(new BaseOption('base'));
	}

	/**
	 * 覆写注册，添加store
	 */
	public register(params: any): void {
		this.registerSecurity(params);

		if (params.store) {
			this.store = params.store;
		}
	}

	/**
	 * 测试接口
	 *
	 * @returns {Promise<any>}
	 */
	public async commonApi(params: IApiParams): Promise<any> {
		const { url, method = 'post', body } = params;
		if (method === 'post') {
			return await this.post(url, body);
		} else {
			return await this.get(url, body);
		}
	}

	/**
	 * 测试接口
	 *
	 * @returns {Promise<any>}
	 */
	public async getApiCacheConfig(params: any): Promise<any> {
		return await this.post('/h5/system/apiCacheConfig', params);
	}

	/** 广告配置 */
	public async getMenuNode(params: any): Promise<any> {
		return await this.post('/h5/menu/node/get', params);
	}

	/** 菜单列表 */
	public async getHomeTags(params?: any): Promise<any> {
		return await this.post('/h5/live/center/home-tag', params).then((res: any): any => {
			if (this.store) {
				this.store.dispatch(updateCategoryList(getVal(res, 'data.dataList', [])));
			}

			return res;
		});
	}

	/** 首页icons */
	public async getHomeIcons(params?: any): Promise<any> {
		return await this.post('/h5/live/center/specialZone', params);
	}

	/** 首页banners */
	public async getHomeBanners(params?: any): Promise<any> {
		return await this.post('/h5/live/center/banners', params);
	}

	/** 首页首屏数据 */
	public async getHomeIndex(params?: any): Promise<any> {
		return await this.post('/h5/indexRegion/init', params);
	}

	/** 首页推荐数据 （分页） */
	public async getHomeindexRecommend(params?: any): Promise<any> {
		return await this.post('/h5/live/center/indexRecommend', params);
	}

	/** 试听列表 */
	public async getCourseAuditionList(params?: any): Promise<any> {
		return await this.post('/h5/topic/getCourseAuditionList', params);
	}

	/** 猜你喜欢课程 */
	public async getPopularCourse(params?: any): Promise<any> {
		return await this.post('/h5/live/center/popularCourse', params);
	}

	/** 兴趣相投 */
	public async getHomeInterest(params?: any): Promise<any> {
		return await this.post('/h5/indexRegion/interest', params);
	}

	/** 听书列表 */
	public async getBookSubjectList(params?: any): Promise<any> {
		return await this.post('/h5/book/bookSubjectList', params);
	}

	/** 获取下一场活动 */
	public async getHotBuyRecently(params?: any): Promise<any> {
		return await this.post('/h5/hot/buy/recently', params);
	}

	/** 检查课程是否能跳转 */
	public async getHotBuyCheck(params?: any): Promise<any> {
		return await this.post('/h5/hot/buy/check', params);
	}

	/** getAppActivity */
	public async getAppActivity(params?: any): Promise<any> {
		return await this.post('/h5/appActivity/getAppActivity', params);
	}

	/** 推荐弹窗 */
	public async getIndexPopup(params?: any): Promise<any> {
		return await this.post('/h5/live/center/popup', params);
	}

	/** 专栏信息 */
	public async channelInfo(channelId: string): Promise<any> {
		return await this.post('/h5/channel/info', { channelId });
	}

	/** 专栏介绍 */
	public async channelDiscountExtend(params?: any): Promise<any> {
		return await this.post('/h5/channel/getDiscountExtend', params);
	}

	/** 话题信息 */
	public async topicInfo(topicId: string): Promise<any> {
		return await this.post('/h5/topic/get', { topicId });
	}

	/** 话题介绍 */
	public async topicProfile(params?: any): Promise<any> {
		return await this.post('/h5/topic/profileList', params);
	}

	/** 是否专业版 */
	public async liveAdmin(liveId: string): Promise<any> {
		return await this.post('/h5/live/admin/admin-flag', { liveId });
	}

	/** 话题列表 */
	public async liveTopics(liveId: string, page?: number): Promise<any> {
		return await this.post('/h5/live/getTopics', {
			liveId,
			showDisplay: 'N', // 是否显示要隐藏的单课
			page: {
				page: page || 1,
				size: 20,
			},
		}).then((res: any): any => getVal(res, 'data.liveTopics', []));
	}

	/** 专栏列表 */
	public async liveChannels(liveId: string, page?: number): Promise<any> {
		return await this.post('/h5/channel/getChannels', {
			liveId,
			page: {
				page: page || 1,
				size: 20,
			},
			isCamp: 'N',
			showDisplay: 'N', // 是否显示已经隐藏掉的专栏
		}).then((res: any): any => getVal(res, 'data.liveChannels', []));
	}

	/** 训练营列表 */
	public async liveTrannings(liveId: string, page?: number): Promise<any> {
		return await this.post('/h5/camp/new/listCamp', {
			liveId,
			page: {
				page: page || 1,
				size: 20,
			},
			showDisplay: 'N', // 是否显示已经隐藏掉的专栏
		}).then((res: any): any => getVal(res, 'data.dataList', []));
	}

	/** 打卡列表 */
	public async liveCamps(liveId: string, page?: number): Promise<any> {
		return await this.post('/h5/camp/display', {
			liveId,
			page: {
				page: page || 1,
				pageSize: 20,
			},
		}).then((res: any): any => getVal(res, 'data.liveCampList', []));
	}
}

export default new ServiceBase();
